import React, { useEffect } from 'react'
import { translate } from 'react-i18next'
import { chronoParams } from '../../../utils/constants'
import { timeToHHMMSS } from '../../../helpers/time.helper'
import { symbolsWithNumbers } from '../../../helpers/symbolsWithNumbers.helper'

const Results = ({ text, t, setGreatTextVisibility }) => {
  useEffect(()=>{
    if(symbolsWithNumbers(text).length>=50) {
      setGreatTextVisibility(true)
    } else {
      setGreatTextVisibility(false)
    }
  }, [text])
  return (
  <div className="results">
    <h6>{t('chonometer.result.title')}</h6>
    <div className="time-result">
      <ul className="time">
        <li>
          <h5>{timeToHHMMSS(symbolsWithNumbers(text).length / chronoParams.normal)}</h5>
          <p className="caption">{t('chonometer.result.normal speed')}</p>
        </li>
        <li>
          <p className="subtitle-1">{timeToHHMMSS(symbolsWithNumbers(text).length / chronoParams.slow)}</p>
          <p className="caption">{t('chonometer.result.slow speed')}</p>
        </li>
        <li>
          <p className="subtitle-1">{timeToHHMMSS(symbolsWithNumbers(text).length / chronoParams.fast)}</p>
          <p className="caption">{t('chonometer.result.fast speed')}</p>
        </li>
      </ul>
      <ul className="words">
        <li>
          <p className="subtitle-1">{symbolsWithNumbers(text).wordCounter}</p>
          <p className="caption">{t('chonometer.result.words')}</p>
        </li>
        <li>
          <p className="subtitle-1">{text.length}</p>
          <p className="caption">{t('chonometer.result.symbols')}</p>
        </li>
        <li>
          <p className="subtitle-1">{(text.length / chronoParams.symbolsOnList).toFixed(1)}</p>
          <p className="caption">{t('chonometer.result.page')}</p>
        </li>
      </ul>
    </div>
  </div>
)}

export default translate('translations')(Results)
